const VERSION = /* @__PURE__ */ (() => "1.27.0" )();
const _ENGINE_TAG = `Babylon Lite v${VERSION}`;

export { VERSION, _ENGINE_TAG };
//# sourceMappingURL=version.js.map
